type PricingRow = {
  effective_dry_unit_price: number | null;
  quantity: number | null;
  dry_total_price: number | null;
  sale_total_price: number | null;
};

export function summarizeEstimatePricing(items: PricingRow[]) {
  const sumKnown = (values: (number | null)[]) => {
    const known = values.filter((value): value is number =>
      value !== null && Number.isFinite(Number(value)) && Number(value) >= 0,
    );
    return known.length ? known.reduce((sum, value) => sum + Number(value), 0) : null;
  };
  const pricedItems = items.filter((item) =>
    item.effective_dry_unit_price !== null &&
    Number.isFinite(Number(item.effective_dry_unit_price)) &&
    Number(item.effective_dry_unit_price) >= 0,
  ).length;
  const hasTotal = (item: PricingRow) =>
    item.effective_dry_unit_price !== null &&
    Number.isFinite(Number(item.effective_dry_unit_price)) &&
    Number(item.effective_dry_unit_price) >= 0 &&
    item.quantity !== null && Number.isFinite(Number(item.quantity)) && Number(item.quantity) >= 0;
  return {
    pricedItems,
    dryTotal: sumKnown(items.map((item) => hasTotal(item) ? item.dry_total_price : null)),
    saleTotal: sumKnown(items.map((item) => hasTotal(item) ? item.sale_total_price : null)),
    dryIncomplete: items.some((item) => !hasTotal(item) || item.dry_total_price === null),
    saleIncomplete: items.some((item) => !hasTotal(item) || item.sale_total_price === null),
  };
}
